import { Domain } from "./domain"
import { EventBase } from "./eventBase"

const CurriculumEvent = {
  SESSION_TIMELINE_SEGMENT_TOGGLED: "Session Timeline Segment Toggled",
  SESSION_TIMELINE_SEGMENT_REORDERED: "Session Timeline Segment Reordered",
  SESSION_TIMELINE_SEGMENT_EDITED: "Session Timeline Segment Edited",
} as const

type CurriculumEvent = EnumValues<typeof CurriculumEvent>

interface CurriculumEventPayload extends Record<string, unknown> {
  /**
   * Not all curriculum events have a curriculum ID. If the event doesn't have a
   * curriculum ID, then use `undefined` to make it explicit.
   */
  curriculumId: string | undefined
}

abstract class CurriculumEventBase<
  TPayload extends CurriculumEventPayload
> extends EventBase<typeof Domain.CURRICULUM, CurriculumEvent, TPayload> {
  constructor(payload: TPayload) {
    super({
      context: payload,
      contentId: payload.curriculumId,
    })
  }

  get domain(): typeof Domain.CURRICULUM {
    return Domain.CURRICULUM
  }
}

export class SessionTimelineSegmentToggled<
  TPayload extends CurriculumEventPayload
> extends CurriculumEventBase<TPayload> {
  constructor(payload: TPayload) {
    super(payload)
  }

  get eventName(): CurriculumEvent {
    return CurriculumEvent.SESSION_TIMELINE_SEGMENT_TOGGLED
  }
}

export class SessionTimelineSegmentReordered<
  TPayload extends CurriculumEventPayload
> extends CurriculumEventBase<TPayload> {
  constructor(payload: TPayload) {
    super(payload)
  }

  get eventName(): CurriculumEvent {
    return CurriculumEvent.SESSION_TIMELINE_SEGMENT_REORDERED
  }
}
export class SessionTimelineSegmentEdited<
  TPayload extends CurriculumEventPayload
> extends CurriculumEventBase<TPayload> {
  constructor(payload: TPayload) {
    super(payload)
  }

  get eventName(): CurriculumEvent {
    return CurriculumEvent.SESSION_TIMELINE_SEGMENT_EDITED
  }
}
